export default __webpack_public_path__ + "static/prestashop-logo-b293d3d0073a8486937db4247adc12c8.webp";